// extracted by mini-css-extract-plugin
module.exports = {"additionalText":"ZgPmt","capitalize":"fn8H-","accType":"HRt7b","buttons":"QjABO"};